import Vue from 'vue'
import axios from 'axios'

import {
  DOWNLOAD_ALL,
  DOWNLOAD_CREATE,
  DOWNLOAD_READ,
  DOWNLOAD_UPDATE,
  DOWNLOAD_DELETE
} from '../actions'

import {
  CLEAR_STORE,
  DOWNLOAD_LOADING,
  DOWNLOAD_SUCCESS,
  DOWNLOAD_ERROR,
  DOWNLOAD_SET,
  DOWNLOADS_SET,
  DOWNLOAD_CURRENT_PAGE_SET,
  DOWNLOAD_PER_PAGE_SET,
  DOWNLOAD_TOTAL_PAGES_SET,
  DOWNLOAD_SEARCH_VALUE_SET
} from '../mutations'

export default {
  state: {
    status: '',
    downloads: {},
    perPage: 15,
    currentPage: 1,
    totalPages: 0,
    searchValue: ''
  },

  mutations: {
    [DOWNLOAD_LOADING]: (state) => {
      state.status = 'loading'
    },
    [DOWNLOAD_SUCCESS]: (state) => {
      state.status = 'success'
    },
    [DOWNLOAD_ERROR]: (state) => {
      state.status = 'error'
    },
    [DOWNLOAD_SET]: (state, resp) => {
      Vue.set(state, 'download', resp)
    },
    [DOWNLOADS_SET]: (state, resp) => {
      Vue.set(state, 'downloads', resp)
    },
    [DOWNLOAD_PER_PAGE_SET]: (state, value) => {
      state.perPage = value
    },
    [DOWNLOAD_CURRENT_PAGE_SET]: (state, value) => {
      state.currentPage = value
    },
    [DOWNLOAD_TOTAL_PAGES_SET]: (state, value) => {
      state.totalPages = value
    },
    [DOWNLOAD_SEARCH_VALUE_SET]: (state, value) => {
      state.searchValue = value
    },
    [CLEAR_STORE]: (state) => {
      Vue.set(state, 'download', {})
      Vue.set(state, 'downloads', [])
    }
  },

  actions: {
    [DOWNLOAD_ALL]: ({ commit, state }) => {
      commit(DOWNLOAD_LOADING)

      let params = {
        page: state.currentPage,
        per_page: state.perPage
      }

      if (state.searchValue && state.searchValue.length) {
        params.search = state.searchValue
      }

      axios({
        url: 'downloads',
        params: params
      })
        .then((resp) => {
          commit(DOWNLOAD_SUCCESS)
          commit(DOWNLOADS_SET, resp.data.data)
          commit(DOWNLOAD_TOTAL_PAGES_SET, resp.data.meta.last_page)
        })
        .catch((resp) => {
          commit(DOWNLOAD_ERROR)
        })
    },

    [DOWNLOAD_READ]: ({ commit }, id) => {
      commit(DOWNLOAD_LOADING)
      commit(DOWNLOAD_SET, {})
      axios({
        url: 'downloads/' + id
      })
        .then((resp) => {
          commit(DOWNLOAD_SUCCESS)
          commit(DOWNLOAD_SET, resp.data.data)
        })
        .catch((resp) => {
          commit(DOWNLOAD_ERROR)
        })
    },

    [DOWNLOAD_CREATE]: ({ commit, getters }, data) => {
      return new Promise((resolve, reject) => {
        commit(DOWNLOAD_LOADING)

        let accountId = getters.getActiveAccountId

        if (!accountId) {
          commit(DOWNLOAD_ERROR)
          return false
        }

        axios({
          method: 'post',
          url: 'accounts/' + accountId + '/downloads',
          data: data
        })
          .then((resp) => {
            commit(DOWNLOAD_SUCCESS)
            resolve(resp)
          })
          .catch((err) => {
            commit(DOWNLOAD_ERROR)
            reject(err)
          })
      })
    },

    [DOWNLOAD_UPDATE]: ({ commit, dispatch }, { id, data }) => {
      commit(DOWNLOAD_LOADING)
      axios({
        method: 'put',
        url: 'downloads/' + id,
        data: data
      })
        .then((resp) => {
          commit(DOWNLOAD_SUCCESS)
          commit(DOWNLOAD_SET, resp.data.data)
          dispatch(DOWNLOAD_ALL)
        })
        .catch((resp) => {
          commit(DOWNLOAD_ERROR)
        })
    },

    [DOWNLOAD_DELETE]: ({ commit, dispatch }, id) => {
      commit(DOWNLOAD_LOADING)

      axios({
        method: 'delete',
        url: 'downloads/' + id
      })
        .then((resp) => {
          commit(DOWNLOAD_SET, {})
          dispatch(DOWNLOAD_ALL)
        })
        .catch((resp) => {
          commit(DOWNLOAD_ERROR)
        })
    }
  }
}
